module.exports = __webpack_public_path__ + "static/media/earth.136883e4.mp4";